{
	"invalidFileFormat": "Invalid file format, valid formats: {{formats}}",
	"multipleFilesUploaded": "Multiple files uploaded",
	"remove": "Remove"
}
